import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import { useSettingsContext } from '../../components/settings';
//
import Main from './Main';
import Header from './header';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import { GAEventPopover, useAnalyticsContext } from '../../analytics';

// ----------------------------------------------------------------------

interface DashboardLayoutProps {
  // eslint-disable-next-line react/no-unused-prop-types
  showNotifications: boolean
}

export default function DashboardLayout(props: DashboardLayoutProps) {
  const { showNotifications } = props;
  const { themeLayout } = useSettingsContext();
  const { sendEvent } = useAnalyticsContext();

  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  const isNavMini = themeLayout === 'mini';

  const handleOpen = () => {
    sendEvent(new GAEventPopover('Navigation_Menu'))
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderNavVertical = <NavVertical openNav={open} onCloseNav={handleClose} />;

  if (isNavMini) {
    return (
      <>
        <Header onOpenNav={handleOpen} showNotifications={showNotifications} />

        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? <NavMini /> : renderNavVertical}

          <Main showNotifications={showNotifications}>
            <Outlet />
          </Main>
        </Box>
      </>
    );
  }

  return (
    <>
      <Header onOpenNav={handleOpen} showNotifications={showNotifications} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main showNotifications={showNotifications}>
          <Outlet />
        </Main>
      </Box>
    </>
  );
}
